import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { CustomTranslateService } from 'src/app/common/services/translate.service';

import { LANG } from '../../constants/constants';
declare var $: any;
declare var WOW: any;

@Component({
    selector: 'ib-sidebar',
    templateUrl: './sidebar_new.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterViewInit {
    bankName = {
        en: 'Demo Bank',
        bn: 'ডেমো ব্যাংক'
    };
    defaultLink: string = '/';
    menuJson: Object[];
    role = '';
    resetRequired = '';
    myAccountsLink: string = '/my-accounts';
    atMyBankLink: string = '/transfer/at-my-bank';
    atOtherBankAccountBeftnLink: string = '/transfer/beftn';
    atOtherBankCardBeftnLink: string = '/transfer/beftnCard';
    atOtherBankAccountLink: string = '/transfer/otherBankAccount';
    atOtherBankCardLink: string = '/transfer/otherBankCard';
    atPendingLink: string = '/transfer/pending-list';

    rechargeLink: string = '/mobile-recharge';
    rechargeStatusLink: string = '/recharge-status';
    rechargeBeneficiaryLink: string = '/recharge-beneficiary';
    rechargePendingTransactionLink: string = '/recharge-pending-transaction';

    payFeeRouterLink: string = '/pay-fee';
    educationFeeHistoryRouterLink: string = '/education-fee-history';
    pendingPaymentRouterLink: string = '/pending-payment-history';

    addMoneyLink: string = '/add-nagad-money';
    addBeneficiaryLink: string = '/add-nagad-beneficiary';
    pendingTransaction: string = '/pending-transaction';

    bkashAddMoneyLink: string = '/bkash-add-money';
    bkashBeneficiaryManagement: string = '/bkash-beneficiary-management';
    bkashPendingTransaction: string = '/bkash-pending-transaction';

    beneficiaryManagementLink: string = '/transfer/beneficiary-management';
    summaryLink: string = '/inquiry/summary';
    statementLink: string = '/inquiry/statement';
    miniStatementLink: string = '/inquiry/mini-statement';
    transferHistoryLink: string = '/history/transfer-history';

    status: string = '';
    ekpayMenus = [];
    userActivity: string;

    branchLocatorLink: string = '/branch-locator';
    branchLocatorMapLink: string = '/branch-locator-map';
    emiCalculatorLink: string = '/emi-calculator';
    advanceLoanCalculatorLink: string = '/advance-loan-calculator';
    chequeBookRequestLink: string = '/cheque-service/request-new-cheque-book';
    hidePendingTransLink: boolean = false;

    // Bill Pay Routes
    BILL_PAY_ELECTRICITY_BILL_ROUTE = '/bills/electricity-bill';
    BILL_PAY_WATER_BILL_ROUTE = '/bills/water-bill';
    BILL_PAY_GAS_BILL_ROUTE = '/bills/gas-bill';
    BILL_PAY_E_SERVICE_ROUTE = '/bills/e-service';
    BILL_PAY_INTERNET_BILL_ROUTE = '/bills/internet-bill';
    BILL_PAY_PENDING_TRANSACTION_ROUTE = '/bills/pending';
    BILL_PAY_TRANSACTION_HISTORY_ROUTE = '/bills/history';

    // Exchange Rate
    EXCHANGE_RATE_ROUTE = '/exchange-rate';

    // Dispute
    NPSB_DISPUTE_ROUTE = 'npsb-dispute';

    // Settings
    MY_PROFILE_ROUTE = '/my-profile';
    CHANGE_PASSWORD_ROUTE = '/change-password';

    // User Activity
    userActivityLink: string = '/user-activity';

    // Transaction Status Inquiry
    transactionStatusInquiryLink: string = '/transfer/transaction-status-inquiry';

    // Transaction Limit
    transactionLimitLink: string = '/transaction-limit';

    // Tax Return Proof Upload
    taxReturnProofLink: string = '/self-service/tax-return-proof';
    autoPayCreateLink: string = '/self-service/create-auto-pay';
    autoPayListLink: string = '/self-service/auto-pay-list';
    // Cheque Service
    positivePayInstruction: string = '/cheque-service/positive-pay-instruction';
    requestNewChequeBook: string = '/cheque-service/request-new-cheque-book';
    manageChequeBookRequests: string = '/cheque-service/cheque-book-requests';
    stopChequeRequest: string = '/cheque-service/stop-cheque-request';
    stopCheckRequestHistory: string = '/cheque-service/stop-cheque-requests';

    // Standing Instructions
    standingInstructionsLink: string = '/standing-instructions';

    constructor(
        private _router: Router,
        private _customTranslateService: CustomTranslateService,
        private _translate: TranslateService,
        private _route: ActivatedRoute
    ) {}

    get bankDisplayName(): string {
        return this.bankName[this._translate.currentLang] || this.bankName.en;
    }

    refreshTransferBeneficiaryMenu(): void {
        const currentUrl = this._router.url;
        this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigateByUrl(this.beneficiaryManagementLink);
        });
    }
    refreshMobileBenificiaryMenu(): void {
        const currentUrl = this._router.url;
        this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigateByUrl(this.rechargeBeneficiaryLink);
        });
    }
    refreshNagadBeneficiaryMenu(): void {
        const currentUrl = this._router.url;
        this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigateByUrl(this.addBeneficiaryLink);
        });
    }
    refreshBkashBeneficiaryMenu(): void {
        const currentUrl = this._router.url;
        this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigateByUrl(this.bkashBeneficiaryManagement);
        });
    }
    closeMobileSidebar(): void {
        document.body.classList.remove('mobile-sidebar-open');
    }

    ngOnInit(): void {
        if (this._route.snapshot.data['home']) {
            this._route.data.subscribe(data => {
                if (data['home'][1]) {
                    this.menuJson = data['home'][1].body.menuJson;
                    this.resetRequired = data['home'][1].body.menuJson;
                }
            });
        }

        this.defaultLink = this.menuJson[0]['leftMenuId'][0];
        this.openMenu(this.defaultLink);
        const lang = localStorage.getItem(LANG);
        // this._translate.setDefaultLang(lang);
        this.changeLanguage(lang);

        // Close mobile sidebar on any navigation (menu item tap)
        this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.closeMobileSidebar();
            }
        });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.setActiveLanguageLink(this._translate.currentLang);

            this.addPlugIns();
        });
    }

    topMenuIcons = {
        1: 'assets/images/icon-my-accounts.svg',
        2: 'assets/images/icon-transfer.svg',
        3: 'assets/images/bkash-logo-white.svg',
        4: 'assets/images/icon-nagad-white.svg',
        5: 'assets/images/icon-bill-pay.svg',
        6: 'assets/images/icon-education-fee.svg',
        7: 'assets/images/icon-mobile-recharge.svg',
        8: 'assets/images/cheque-service.svg',
        9: 'assets/images/icon-self-service.svg',
        10: 'assets/images/icon-inquiry.svg',
        11: 'assets/images/icon-history.svg',
        12: 'assets/images/icon-others.svg',
        13: 'assets/images/settings.svg'
    };

    menuIcons = {
        atMyBank: 'assets/images/icon-ft-own.svg',
        beftnToAccount: 'assets/images/icon-ft-other-bank-beftn.svg',
        beftnToCard: 'assets/images/icon-beftn-card.svg',
        npsbToCard: 'assets/images/icon-npsb-card.svg',
        npsbToAccount: 'assets/images/icon-npsb-account.svg',
        transferBeneficiaryManagement: 'assets/images/icon-beneficiary-management.svg',
        commonPendingTransactions: 'assets/images/pen-trans-icon.svg',
        createAutoPay: 'assets/images/icon-self-service.svg',
        autoPayList: 'assets/images/icon-self-service.svg',
        bKashTransfer: 'assets/images/icon-transfer.svg',
        bKashBeneficiaryManagement: 'assets/images/icon-beneficiary-management.svg',
        bKashPendingTransactions: 'assets/images/pen-trans-icon.svg',
        nagadTransfer: 'assets/images/icon-transfer.svg',
        nagadBeneficiaryManagement: 'assets/images/icon-beneficiary-management.svg',
        nagadPendingTransactions: 'assets/images/pen-trans-icon.svg',
        mobileRechargeTransfer: 'assets/images/icon-sub-menu-recharge.svg',
        mobileRechargeBeneficiaryManagement: 'assets/images/icon-beneficiary-management.svg',
        mobileRechargePendingTransactions: 'assets/images/pen-trans-icon.svg',
        summary: 'assets/images/icon-summary.svg',
        statement: 'assets/images/icon-statement.svg',
        miniStatement: 'assets/images/icon-mini-statement.svg',
        transferHistory: 'assets/images/pen-trans-icon.svg',
        electricityBill: 'assets/images/icons-electricity.svg',
        waterBill: 'assets/images/icon-water-outline.svg',
        gasBill: 'assets/images/icon-gas.svg',
        internetBill: 'assets/images/icon-internet.svg',
        telephoneBill: 'assets/images/icon-telephone.svg',
        eService: 'assets/images/icon-eservices.svg',
        pending: 'assets/images/pen-trans-icon.svg',
        history: 'assets/images/pen-trans-icon.svg',
        branchLocator: 'assets/images/icon-brach-locator-map.svg',
        emiCalculator: 'assets/images/icon-emi-calculator.svg',
        advanceLoanCalculator: 'assets/images/icon-advance-loan-calculator.svg',
        payFee: 'assets/images/icon-fee-bill-pay.svg',
        educationFeeHistory: 'assets/images/icon-history.svg',
        pendingPaymentHistory: 'assets/images/icon-pending.svg',
        exchangeRate: 'assets/images/icon-exchange-rate.svg',
        npsbDispute: 'assets/images/icon-dispute.svg',
        myProfile: 'assets/images/icon-user-management.svg',
        changePassword: 'assets/images/icon-password.svg',
        userActivity: 'assets/images/icon-user-activity.svg',
        transactionStatusInquiry: 'assets/images/icon-history.svg',
        transactionLimit: 'assets/images/icon-trxn-limit.svg',
        taxReturnProof: 'assets/images/icon-self-service.svg',
        positivePayInstruction: 'assets/images/cheque-service.svg',
        requestNewChequeBook: 'assets/images/cheque-service.svg',
        manageChequeBookRequests: 'assets/images/cheque-service.svg',
        stopChequeRequest: 'assets/images/cheque-service.svg',
        stopCheckRequestHistory: 'assets/images/cheque-service.svg',
        standingInstructions: 'assets/images/icon-self-service.svg'
    };

    getRouterLinkByKey(key): string {
        if (key == 'My Accounts') {
            return this.myAccountsLink;
        }
        if (key == 'atMyBank') {
            return this.atMyBankLink;
        }
        if (key == 'beftnToAccount') {
            return this.atOtherBankAccountBeftnLink;
        }
        if (key == 'beftnToCard') {
            return this.atOtherBankCardBeftnLink;
        }
        if (key == 'npsbToAccount') {
            return this.atOtherBankAccountLink;
        }
        if (key == 'npsbToCard') {
            return this.atOtherBankCardLink;
        }
        if (key == 'transferBeneficiaryManagement') {
            return this.beneficiaryManagementLink;
        }
        if (key == 'commonPendingTransactions') {
            return this.atPendingLink;
        }
        if (key == 'createAutoPay') {
            return this.autoPayCreateLink;
        }
        if (key == 'autoPayList') {
            return this.autoPayListLink;
        }
        if (key == 'bKashTransfer') {
            return this.bkashAddMoneyLink;
        }
        if (key == 'bKashBeneficiaryManagement') {
            return this.bkashBeneficiaryManagement;
        }
        if (key == 'bKashPendingTransactions') {
            return this.bkashPendingTransaction;
        }
        if (key == 'nagadTransfer') {
            return this.addMoneyLink;
        }
        if (key == 'nagadBeneficiaryManagement') {
            return this.addBeneficiaryLink;
        }
        if (key == 'nagadPendingTransactions') {
            return this.pendingTransaction;
        }
        if (key == 'mobileRechargeTransfer') {
            return this.rechargeLink;
        }
        if (key == 'mobileRechargeBeneficiaryManagement') {
            return this.rechargeBeneficiaryLink;
        }
        if (key == 'mobileRechargePendingTransactions') {
            return this.rechargePendingTransactionLink;
        }
        if (key == 'summary') {
            return this.summaryLink;
        }
        if (key == 'statement') {
            return this.statementLink;
        }
        if (key == 'miniStatement') {
            return this.miniStatementLink;
        }
        if (key == 'transferHistory') {
            return this.transferHistoryLink;
        }
        if (key == 'branchLocator') {
            return this.branchLocatorLink;
        }
        if (key == 'branchLocatorMap') {
            return this.branchLocatorMapLink;
        }
        if (key == 'emiCalculator') {
            return this.emiCalculatorLink;
        }
        if (key == 'advanceLoanCalculator') {
            return this.advanceLoanCalculatorLink;
        }
        if (key === 'electricityBill') {
            return this.BILL_PAY_ELECTRICITY_BILL_ROUTE;
        }
        if (key === 'waterBill') {
            return this.BILL_PAY_WATER_BILL_ROUTE;
        }
        if (key === 'gasBill') {
            return this.BILL_PAY_GAS_BILL_ROUTE;
        }
        if (key === 'pending') {
            return this.BILL_PAY_PENDING_TRANSACTION_ROUTE;
        }
        if (key === 'history') {
            return this.BILL_PAY_TRANSACTION_HISTORY_ROUTE;
        }
        if (key === 'payFee') {
            return this.payFeeRouterLink;
        }
        if (key === 'educationFeeHistory') {
            return this.educationFeeHistoryRouterLink;
        }
        if (key === 'pendingPaymentHistory') {
            return this.pendingPaymentRouterLink;
        }
        if (key === 'eService') {
            return this.BILL_PAY_E_SERVICE_ROUTE;
        }
        if (key === 'internetBill') {
            return this.BILL_PAY_INTERNET_BILL_ROUTE;
        }
        if (key === 'exchangeRate') {
            return this.EXCHANGE_RATE_ROUTE;
        }
        if (key === 'npsbDispute') {
            return this.NPSB_DISPUTE_ROUTE;
        }
        if (key === 'myProfile') {
            return this.MY_PROFILE_ROUTE;
        }
        if (key === 'changePassword') {
            return this.CHANGE_PASSWORD_ROUTE;
        }
        if (key === 'userActivity') {
            return this.userActivityLink;
        }
        if (key === 'transactionStatusInquiry') {
            return this.transactionStatusInquiryLink;
        }
        if (key === 'transactionLimit') {
            return this.transactionLimitLink;
        }
        if (key === 'taxReturnProof') {
            return this.taxReturnProofLink;
        }
        if (key === 'positivePayInstruction') {
            return this.positivePayInstruction;
        }
        if (key === 'requestNewChequeBook') {
            return this.requestNewChequeBook;
        }
        if (key === 'manageChequeBookRequests') {
            return this.manageChequeBookRequests;
        }
        if (key === 'stopChequeRequest') {
            return this.stopChequeRequest;
        }
        if (key === 'stopCheckRequestHistory') {
            return this.stopCheckRequestHistory;
        }
        if (key === 'standingInstructions') {
            return this.standingInstructionsLink;
        }
    }

    addPlugIns(): void {
        // Skip the jQuery custom scrollbar plugin on mobile — it wraps the
        // scroll container in a div with overflow:hidden + a fixed inline
        // height, which prevents native touch scrolling on Android/iOS.
        // On desktop (>= 992px) the plugin works fine and is kept.
        if (window.innerWidth >= 992) {
            $('.comment-scrollbar').mCustomScrollbar({
                axis: 'y',
                autoHideScrollbar: true,
                scrollbarPosition: 'outside',
                theme: 'light-1',
                scrollInertia: 200,
                mouseWheel: { deltaFactor: 120 }
            });
        }

        // metisMenu-active.js
        $('#metismenu').metisMenu();

        // main.js
        $('#sidebarCollapse').on('click', () => {
            $('#sidebar').toggleClass('active');
            $('#footer').toggleClass('active');
        });
        $('.sicker-menu').sticky({
            topSpacing: 0
        });
        $('#sidebarCollapse').on('click', () => {
            $('body').toggleClass('mini-navbar');
        });
        $(document).on('click', '.header-right-menu .dropdown-menu', e => {
            e.stopPropagation();
        });
        $(document).on('click', '.header-right-menu .dropdown-menu', e => {
            e.stopPropagation();
        });

        new WOW().init();
    }

    topMenu(topMenuId): string {
        $(document).on('click', e => {
            e.stopPropagation();
        });
        if (topMenuId == 'My Accounts') {
            return this.myAccountsLink;
        }
    }

    openMenu(url): void {
        if (url) {
            this._router.navigate([url]);
        } else if (url?.indexOf(this.bkashAddMoneyLink) !== -1 || url?.indexOf(this.bkashBeneficiaryManagement) !== -1 || url?.indexOf(this.bkashPendingTransaction) !== -1) {
            $('#bkashTopupMenu').addClass('active');
        } else if (url?.indexOf(this.branchLocatorLink) !== -1 || url?.indexOf(this.branchLocatorMapLink) !== -1 || url?.indexOf(this.emiCalculatorLink) !== -1 || url?.indexOf(this.advanceLoanCalculatorLink) !== -1 || url?.indexOf(this.chequeBookRequestLink) !== -1) {
            $('#othersTopupMenu').addClass('active');
        } else if (url?.indexOf(this.payFeeRouterLink) !== -1 || url?.indexOf(this.educationFeeHistoryRouterLink) !== -1) {
            $('#schoolFeeTopUpMenu').addClass('active');
        }
    }

    changeLanguage(lan: string): void {
        this._translate.use(lan);
        this.setActiveLanguageLink(lan);
        localStorage.setItem(LANG, lan);
        this._customTranslateService.languageUpdate$.next(lan);
    }

    setActiveLanguageLink(lang: String): void {
        if (lang === 'en') {
            $('#englishLangLink').addClass('active');
            $('#banglaLangLink').removeClass('active');
            document.documentElement.setAttribute('lang', 'en');
        } else if (lang === 'bn') {
            $('#banglaLangLink').addClass('active');
            $('#englishLangLink').removeClass('active');
            document.documentElement.setAttribute('lang', 'bn');
        }
    }
}
